"use client";

import React from "react";
import ReceiptBarcode from "../../ReceiptBarcode";
import styles from "../css/TermalReciept.module.css";

function Line() {
  return <div className={styles.line} />;
}

function CopyHeader({ label }) {
  return (
    <div className={styles.copyHeader}>
      {"********** "}{label}{" **********"}
    </div>
  );
}

export default function ThermalReceipt({ data, copyLabel = "ORIGINAL" }) {
  const pharmacy = {
    name: "DURBAN NORTH PHARMACY",
    addr1: "DOCNOR MEDICAL CENTRE",
    addr2: "35 UMHLANGA ROCKS DRIVE",
    city: "DURBAN NORTH",
    tel: "TEL:\t031 5637577",
    fax: "FAX:\t031 5637736",
    vatNo: "4480257841",
  };

  const patientName = `${data?.patient?.firstname || ""} ${data?.patient?.surname || ""}`.trim();
  const address = data?.patient?.homeaddress || "";
  const accNo = data?.patient?.patientid ?? "";
  const items = Array.isArray(data?.items) ? data.items : [];
  const total = Number(data?.total || 0);
  const tax = Number(data?.tax || 0);
  const cashier = data?.cashier != null ? String(data.cashier) : "";
  const tillno = data?.tillno != null && data.tillno !== "" ? String(data.tillno) : "";
  const timeStr = (() => {
    const d = data?.time ? new Date(data.time) : null;
    if (!d || isNaN(d.getTime())) return "";
    const hh = d.getHours();
    const h12 = ((hh + 11) % 12) + 1;
    const min = String(d.getMinutes()).padStart(2, "0");
    const ampm = hh >= 12 ? "PM" : "AM";
    return `${String(h12).padStart(2, "0")}:${min} ${ampm}`;
  })();
  const dateStr = (() => {
    const d = data?.date ? new Date(data.date) : null;
    if (!d || isNaN(d.getTime())) return "";
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  })();

  return (
    <div className={styles.root}>
      <div className={styles.centerBold}>
        <div>{"====================================="}</div>
        <div>{pharmacy.name}</div>
        <div>{"====================================="}</div>
      </div>

      <div className={styles.marginTop6}>
        <div>{pharmacy.addr1}</div>
        <div>{pharmacy.addr2}</div>
        <div className={styles.marginTop4}>RECIEPT NO: {data?.recieptno || ""}</div>
        <div>DATE: {dateStr}</div>
      </div>

      <div className={styles.marginTop6}>
        <div>{pharmacy.city}</div>
        <div>{pharmacy.tel}</div>
        <div>{pharmacy.fax}</div>
      </div>

      <CopyHeader label={copyLabel} />

      <Line />

      <div className={styles.rowBetween12}>
        <div className={styles.nowrap}>TAX INVOICE</div>
        <div />
      </div>

      <div className={styles.rowBetween12}>
        <div className={styles.nowrap}>V.A.T REG.NO:</div>
        <div className={styles.nowrap}>{pharmacy.vatNo}</div>
      </div>

      <div className={styles.rowBetween12}>
        <div>CASHIER:</div>
        <div>{cashier || ""}</div>
      </div>
      <div className={styles.rowBetween12}>
        <div>TILL NO:</div>
        <div>{tillno || ""}</div>
      </div>

      <Line />

      <div>
        <div>{patientName || "[PATIENT NAME AND SURNAME]"}</div>
        <div>{address || ""}</div>
        <div>ACC NO: {accNo || "[ACC NO]"}</div>
      </div>

      <Line />

      <div>
        {items.map((it) => {
          const qty = Number(it.quantity || 0);
          const unit = Number(it.unitPrice || 0);
          const lineTotal = Number(it.total || 0);
          return (
            <div key={it.sku} className={styles.item}>
              <div
                className={styles.itemTopGrid}
              >
                <div>{it.name || "[DRUG NAME]"}</div>
                <div className={styles.textRight}>{it.packsize || "[PACK SIZE]"}</div>
              </div>

              <div
                className={styles.itemBottomGrid}
              >
                <div>{it.barcode ? `[${it.barcode}]` : "[BARCODE]"}</div>
                <div className={`${styles.textRight} ${styles.nowrap}`}>{`${qty} x R${unit.toFixed(2)}`}</div>
                <div className={styles.textCenter}>=</div>
                <div className={`${styles.textRight} ${styles.nowrap}`}>{`R${lineTotal.toFixed(2)}`}</div>
              </div>
            </div>
          );
        })}
      </div>

      <Line />

      <div className={styles.rowBetweenBold}>
        <div>{"TOTAL >>>>:"}</div>
        <div>R {total.toFixed(2)}</div>
      </div>
      <div className={styles.rowBetween}>
        <div>(INCL. VAT @ 15%):</div>
        <div>R {tax.toFixed(2)}</div>
      </div>

      <Line />

      <div className={styles.rowBetween}>
        <div>COLLECT AMOUNT:</div>
        <div>R {total.toFixed(2)}</div>
      </div>

      <div className={`${styles.rowBetween} ${styles.marginTop6}`}>
        <div>TIME: {timeStr}</div>
        <div>{`****    ${items.length} ITEM/S`}</div>
      </div>

      <Line />
      <div className={`${styles.centerText} ${styles.marginTop4}`}>
        <div>NO MEDICINES ARE RETURNABLE</div>
        <div>THANK YOU FOR YOUR SUPPORT</div>
        <div>VALID EXCHANGES WITHIN 2 DAYS OF SALE</div>
      </div>

      <div className={styles.footerBarcode}>
        <ReceiptBarcode value={data?.recieptno || ""} height={38} />
      </div>
    </div>
  );
}
